import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getSurveyJSON } from "../../../../services/jsons";
import CardSurveys from "../../../reusable/CardSurveys";
import {
  countries,
  countries_en,
} from "../../../../utils/constants/nameCountry";
import { TOOLTIP_STYLE } from "../../../../utils/constants/graphConfigs";
import { useCurrentLanguage } from "../../../../hooks/useCurrentLanguage";

export default function PoliticalBeliefs({ survey }) {
  const { type } = useParams();
  const { language } = useCurrentLanguage();

  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState();
  const [selectedSurvey, setSelectedSurvey] = useState(survey ?? type ?? "emv");

  function makeSeries(data) {
    const seriesNames = Object.keys(data.values);

    return seriesNames.map((name) => {
      const obj = {
        name: data.answers[language][name],
        type: "bar",
        stack: "total",
        emphasis: {
          focus: "series",
        },
        data: data.values[name],
      };

      if (seriesNames.indexOf(name) === seriesNames.length - 1) {
        obj.itemStyle = { borderRadius: [0, 20, 20, 0] };
      } else {
        obj.itemStyle = { borderRadius: 0 };
      }

      return obj;
    });
  }

  useEffect(() => {
    const getData = async () => {
      const response = await getSurveyJSON("politicalViews");

      setData(response);
      setIsLoading(false);
    };

    getData();
  }, []);

  useEffect(() => {
    setSelectedSurvey(survey);
  }, [survey]);

  useEffect(() => {
    if (!isLoading && data !== undefined && selectedSurvey) {
      const translatedCountries = data[selectedSurvey].countries.map(
        (country) => {
          return language === "en" ? countries_en[country] : countries[country];
        }
      );
      const series = makeSeries(data[selectedSurvey]);
      const options = {
        textStyle: {
          fontFamily: "Open Sans",
        },
        color: ["#305EA9", "#6CCDEF", "#8DBA38", "#F4DB4E"],
        tooltip: {
          trigger: "axis",
          ...TOOLTIP_STYLE,
          valueFormatter: (value) => {
            return value.toFixed(1) + "%";
          },
          axisPointer: {
            type: "shadow",
          },
          formatter: (props) => {
            const divs = [];

            divs.push("<span>" + props[0].axisValue + "</span></br>");
            props.forEach((line) => {
              divs.push(
                "<div>" +
                  line.marker +
                  " " +
                  line.seriesName +
                  ": " +
                  line.data.toFixed(1) +
                  "%</div>"
              );
            });
            return divs.join("");
          },
        },
        legend: {
          top: "2%",
          left: "10%",
          type: "scroll",
          data: series.map((s) => s.name),
        },
        grid: {
          top: "9%",
          left: "3%",
          right: "4%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          max: 100,
          nameTextStyle: {
            fontFamily: ["Open Sans", "sans-serif"],
            fontSize: 15,
          },
        },
        yAxis: {
          type: "category",
          data: translatedCountries,
          nameTextStyle: {
            fontFamily: ["Open Sans", "sans-serif"],
            fontSize: 15,
          },
        },
        series: series,
      };
      setOptions(options);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, selectedSurvey]);

  return (
    <CardSurveys
      isLoading={isLoading}
      options={options}
      graphTitle={data ? data[selectedSurvey].question[language] : null}
    />
  );
}
